export default __webpack_public_path__ + "static/media/8818 - Niftynaut.60d72a07.jpeg";